import React, { useState, useEffect } from "react";
import { navLinks } from "./data"; // Import navLinks data
import NavItem from "./NavItem"; // Import NavItem component

const NavLinks = () => {
  const [activeSection, setActiveSection] = useState("home"); // Default to "home"

  useEffect(() => {
    const sections = document.querySelectorAll("section");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id); // Set active section based on intersection
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the section is visible
    );

    sections.forEach((section) => observer.observe(section)); // Observe all sections

    return () => observer.disconnect(); // Clean up observer on unmount
  }, []);

  return (
    <nav id="navbar" className="nav-menu navbar">
      <ul>
        {navLinks.map(({ id, url, text, icon }) => (
          <NavItem
            key={id}
            id={id}
            url={url}
            text={text}
            icon={icon}
            isActive={activeSection === url.slice(1)} // Pass active state to NavItem
          />
        ))}
      </ul>
    </nav>
  );
};

export default NavLinks;
